<script lang="ts">
  import { fade } from 'svelte/transition';
  import type { Toast } from './Toasts.svelte';

  let { toast, onRemove }: { toast: Toast; onRemove: () => void } = $props();
  let remaining = $derived(toast.duration);

  let frameId = -1;
  $effect(() => {
    let lastStamp: number;
    function onFrame(stamp: number) {
      if (remaining <= 0) {
        return;
      }

      if (lastStamp !== undefined) {
        remaining -= stamp - lastStamp;
      }

      if (remaining <= 0) {
        onRemove();
      } else {
        frameId = requestAnimationFrame(onFrame);
      }

      lastStamp = stamp;
    }

    onFrame(performance.now());
    return () => cancelAnimationFrame(frameId);
  });
</script>

<button
  class={[`alert relative cursor-pointer md:w-64`, `alert-${toast.type}`, toast.class]}
  onclick={onRemove}
  out:fade={{ duration: 200 }}
>
  {toast.message}
  <progress
    class={['progress progress-neutral absolute -bottom-px left-0 w-full opacity-30']}
    value={Math.max(0, Math.min(100, (remaining / toast.duration) * 100))}
    max="100"
  ></progress>
</button>
